import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {RepositoryMilestoneNewPageQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryMilestoneNewPageQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryMilestoneNewPageQuery'

import {issuesAppBuilder} from '../config/app-builder'

// RepositoryDataResponse exposes the errors array so handleRepositoryDataError can detect FORBIDDEN/SAML.
export type MilestoneNewPayload = RepositoryDataResponse<RepositoryMilestoneNewPageQueryQuery>

export function buildMilestoneNewRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('milestoneNewRoute', {
    path: '/:owner/:repo/milestones/new',
    queries: [
      mainQuery<MilestoneNewPayload>({
        // owner/name are resolved from the pathname by the BFF, so we only
        // need to forward the pathname and the persisted-query id.
        queryDeps: ({pathname}) => ({
          pathname,
          searchParams: {
            queryId: RepositoryMilestoneNewPageQuery,
          },
        }),
      }),
    ],
  })
}

export const milestoneNewRoute = buildMilestoneNewRoute(issuesAppBuilder)
